import React from 'react';
import { useLocationSearch } from '../hooks/useLocationSearch';
import { useLocationPagination } from '../hooks/useLocationPagination';
import { PaginationProvider } from '../contexts/PaginationContext';
import LocationLayout from '../components/layout/LocationLayout';
import NoResults from '../components/noResults/NoResults';

const Widget = () => {
	// Custom hooks for separation of concerns
	const { paginationData, currentPage, handlePageChange } =
		useLocationPagination();
	const {
		isLoading,
		errorMsg,
		noResults,
		tileData,
		locationCount,
		allLocationData,
		showMap,
		coordinates,
		setRange,
		resetTriggers
	} = useLocationSearch(paginationData);

	// Loading state
	if (isLoading) return <div>Loading...</div>;

	// Error state
	if (errorMsg) return <div>Error: something went wrong</div>;

	// No results state
	if (noResults) return <NoResults isNoResults onRangeChange={setRange} />;

	// Main layout
	return (
		<PaginationProvider
			value={{
				totalCount: locationCount,
				allData: allLocationData,
				onPageChange: handlePageChange,
				resetTriggers,
				currentPage
			}}
		>
			<div className="location-search-container">
				<LocationLayout
					tileData={tileData}
					showMap={showMap}
					coordinates={coordinates}
				/>
			</div>
		</PaginationProvider>
	);
};

export default Widget;
